/**
 * Copyright (c) @talatkuyuk AKA @ipikuka
 * SPDX-License-Identifier: MPL-2.0
 */

// for who needs to parse and get the fronmatter and stripped source
export { getFrontmatter } from "./getFrontmatter.js";
